export class AdminUserModel {
  static ROLES = {
    ROLE_ADMINISTRATOR: {
      CODE: 'ROLE_ADMIN',
      DESC: 'Administrador',
    },
    ROLE_SUPER_ADMIN: {
      CODE: 'ROLE_SUPER_ADMIN',
      DESC: 'Super Administrador',
    },
    ROLE_MODERATOR: {
      CODE: 'ROLE_MODERATOR',
      DESC: 'Moderador',
    },
    ROLE_SUPPORT: {
      CODE: 'ROLE_SUPPORT',
      DESC: 'Suporte',
    },
  };

  id: string;
  name: string;
  email: string;
  phone?: string;
  department?: string;
  position?: string;
  roles?: string[];
  permissions?: string[];
  isActive?: boolean;
  lastLoginAt?: string;
  createdAt?: string;
  updatedAt?: string;

  // Campos para formulário
  password?: string;
  retypedPassword?: string;
  newPassword?: string;
  newRetypedPassword?: string;
  oldPassword?: string;

  // Campos para compatibilidade com componentes existentes (deprecated)
  enabled?: boolean;
  avatar?: any;
  cnpj?: string;
  agentsCount?: number;
  chatsCount?: number;
  createdBy?: string;
  updatedBy?: string;
}
